import { HttpClient } from '@angular/common/http';
import { Component, DestroyRef, ElementRef, inject, OnInit } from '@angular/core';
import { Context, User, UserProfile } from '../../models/context.model';
import { ContextService } from '../../services/context.service';
import { Utilities } from '../../providers/utilities';
import { AuthService } from '../../auth/auth.service';
import { UiAvatarImageComponent } from '../ui-avatar/ui-avatar-image.component';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

// import { AuthService } from 'src/app/shared/auth/auth.service';
// import { NotificationsService } from 'src/app/shared/services/notifications.service';
// import { CompactModeService } from 'src/app/shared/services/compact-mode.service';

@Component({
	selector: 'up-top-header',
	templateUrl: './up-top-header.component.html',
	styleUrls: [/*'../styles/scss/_variables.scss', '../styles/scss/_all.scss'*/ './up-top-header.component.scss'],
	standalone: true,
	imports: [CommonModule, UiAvatarImageComponent, MatIconModule, MatBadgeModule]
})
export class UpTopHeaderComponent implements OnInit {

	readonly #destroyRef = inject(DestroyRef);

	dashboard: any[] = [];
	user: User = new User();
	profiles: UserProfile[] = [];
	platformId = 0;
	employeeBasicNetPlatformId = 3;
	notificationBadgeAmount: number = 0;

	showApps = false;
	showUser = false;

	environment = {
		loginUrl: '',
		logoffUrl: '',
		landingUrl: '',
		baseSSOUrl: '',
		basicNetBaseUrl: '',
		basicAppBaseUrl: '',
		baseResourceUrl: '',
		isAuthenticated: true
	};

	landingUrl = '/';

	//se il token è popolato variabile popoalta altrimenti undefined
	isLogged: any;

	compactMode: boolean = false;

	constructor(
		private contextService: ContextService,
		private httpClient: HttpClient,
		public elem: ElementRef,
		private authService: AuthService,
		// private notificationsService: NotificationsService,
		// private compactModeService: CompactModeService
	) { }

	public ngOnInit() {
		this.setEnvironmentParams();
		this.authService.getTokenObservable
			.pipe(takeUntilDestroyed(this.#destroyRef)
			)
			.subscribe((res) => {
				this.isLogged = res;
			});

		// Sottoscrizione alle notifiche per aggiornare il numero nel badge
		// this.notificationsService.broadcastNotifications().subscribe((n) => (this.notificationBadgeAmount = this.notificationsService.getNotificationsTotalCount()));

		this.contextService.getObservableContext()
			.pipe(
				filter((context) => !!context),
				takeUntilDestroyed(this.#destroyRef)
			)
			.subscribe(
				{
					next: (context: Context) => {
						this.dashboard = this.manageDashboard(context?.Current?.Page?.Header?.Dashboard?.Links ?? []);
						this.user = context.Current.User;
						this.profiles = context.Current.User.UserProfiles ?? [];
						console.warn('platform id da gestire');
						this.platformId = 3;
						this.landingUrl = context.Settings.AppPaths.Local?.Base ?? '/';
						if (this.user && this.profiles) {
							this.landingUrl = this.profiles.find((p) => p.Id === this.user.CurrentProfileId)?.LandingUrl ?? '/';
							this.environment.landingUrl = this.landingUrl;
						}
					},
					error: (err: any) => {
						console.error(err)
					}
				}
			);

		// this.compactModeService.setInitialCompactMode();

		// this.compactModeService.compactMode$.subscribe((value) => {
		// 	this.compactMode = value;
		// });
	}

	public login() {
		this.authService.login();
	}

	public logoff() {
		this.authService.logout();
	}

	public changeProfile(profile: UserProfile) {
		const baseAccountsUrl = this.contextService.context.Settings.AppPaths.Core?.Base;
		const fullUrl = baseAccountsUrl + '/Account/BrowseAs';

		const obj = {
			browseId: profile.Company?.GroupId + '',
			profileId: profile.Id + '',
			clientId: this.contextService.context.Current.User.ClientId + ''
		};

		this.httpClient
			.get(Utilities.CleanUrl(fullUrl), { params: obj, withCredentials: true })
			.subscribe(() => (location.href = location.href = profile.LandingUrl ?? '/'));
	}

	public goToBasicPersonal() {
		location.href = this.environment.basicNetBaseUrl + '/Home/Personal';
	}

	private setEnvironmentParams() {
		this.environment.baseResourceUrl = this.contextService.context.Settings.AppPaths.Core?.Api + '/resources';
		this.environment.landingUrl = this.landingUrl;
		this.environment.loginUrl = this.contextService.context.Settings.LoginUrl ?? '/';
		this.environment.logoffUrl = this.contextService.context.Settings.LogoffUrl ?? '/';
		this.environment.basicAppBaseUrl = this.contextService.context.Settings.AppPaths.BasicApp?.Base ?? '/';
		this.environment.basicNetBaseUrl = this.contextService.context.Settings.AppPaths.BasicNet?.Base ?? '/';
		this.environment.baseSSOUrl = this.contextService.context.Settings.AppPaths.BasicNet?.Base ?? '/';
	}

	private manageDashboard(links: any[]): any[] {
		const linkMap = new Map<string, Array<any>>();

		links.forEach((link) => {
			if (!linkMap.has(link.ParentMenuId)) {
				linkMap.set(link.ParentMenuId, [link]);
			} else {
				linkMap.get(link.ParentMenuId)?.push(link);
			}
		});

		return Array.from(linkMap.values()); // return Object.values(groupBy(links, l => l.ParentMenuId));
	}

	togglenotificationsSidebar() {
		// this.notificationsService.toggleSidebarVisible();
	}

	outsideUserTab(e: any) {
		if (!e.target?.className?.includes('userTabClickNuller')) {
			if (this.showUser) this.showUser = false;
		}
	}

	toggleCompactMode() {
		// this.compactModeService.toggleCompactMode();
	}
}
